import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class DeOndeClienteVeioService {
	constructor(private apiService: ApiService) {}

	get(id: number): Observable<any> {
		const url = `/de-onde-cliente-veio/${id}`
		return this.apiService.get(url)
	}

	getAll(filtro?): Observable<any> {
		const url = `/de-onde-cliente-veio`
		return this.apiService.get(url, filtro)
	}

	post(form): Observable<any> {
		const url = '/de-onde-cliente-veio'
		return this.apiService.post(url, form)
	}

	put(id: string, form): Observable<any> {
		const url = `/de-onde-cliente-veio/${id}`
		return this.apiService.post(url, form)
	}

	delete(id: number): Observable<any> {
		const url = `/de-onde-cliente-veio/${id}`
		return this.apiService.delete(url)
	}

	reativar(id: number): Observable<any> {
		let url = `/de-onde-cliente-veio/reativar/${id}`
		return this.apiService.get(url)
	}
}
